<template>
  <div v-if="templateRevision && template">
    <h1>Copy revision</h1>
    <v-btn :to="{ name: 'revision', params: { id: $route.params.id } }">
      <v-icon>chevron_left</v-icon>Revision
    </v-btn>
    <h3>Information</h3>
    <v-text-field
      label="Revision Id"
      :value="templateRevision.id"
      outline
      readonly
    />
    <v-text-field label="Template Id" :value="template.id" outline readonly />
    <v-text-field
      label="Template Code"
      :value="template.code"
      outline
      readonly
    />
    <v-text-field
      label="Template Name"
      :value="template.name"
      outline
      readonly
    />
    <v-alert :value="true" color="info"
      >Choose which template you wish to copy this revision from the list below.
      The current template is marked with 3 red stars if you wish to copy it
      within the same template.</v-alert
    >
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="templates"
      v-if="templates"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <span>{{ props.item.id }}</span>
            <span
              v-if="props.item.id == template.id"
              style="color: red; font-weight: bold; font-size: 1.2em"
              >***</span
            >
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.name }}</td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="copyRevision(props.item)" v-on="on" small>
                  <v-icon>file_copy</v-icon>Copy
                </v-btn>
              </template>
              <span>Copy revision to this template</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "RevisionCopy",
  metaInfo() {
    return {
      title: "Revision copy",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  data() {
    return {
      templateRevision: null,
      template: null,
      templates: null,
      archived: false,
      headers: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Code",
          value: "code",
        },
        {
          text: "Name",
          value: "name",
        },
        {
          text: " ",
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "code",
        descending: false,
      },
    };
  },
  methods: {
    fetchTemplateRevision() {
      nbmlaw
        .get(`/cors/admin/document/templateRevisions/${this.$route.params.id}`)
        .then((response) => {
          // console.log(response.data);
          this.templateRevision = response.data;
        })
        .catch(() => {});
    },
    fetchTemplate() {
      nbmlaw
        .get(
          `/cors/admin/document/templateRevisions/${this.$route.params.id}/snippet/template`
        )
        .then((response) => {
          // console.log(response.data);
          this.template = response.data;
        });
    },
    fetchTemplates() {
      nbmlaw
        .get(`/cors/admin/document/templates/archived/${this.archived}`)
        .then((response) => {
          // console.log(response.data);
          this.templates = response.data;
        });
    },
    copyRevision(template) {
      nbmlaw
        .post(
          `/cors/admin/document/templateRevisions/${this.$route.params.id}/copy/${template.id}`,
          null
        )
        .then((response) => {
          // console.log(response.data);
          this.$router.push({
            name: "revision",
            params: { id: response.data },
          });
        });
    },
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchTemplateRevision();
        this.fetchTemplate();
      },
    },
  },
  created() {
    this.fetchTemplates();
  },
};
</script>
